import { render, staticRenderFns } from "./PermissionInputs.vue?vue&type=template&id=b88ac55a&"
import script from "./PermissionInputs.vue?vue&type=script&lang=ts&"
export * from "./PermissionInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports